export const TALKDESK_DOWNGRADES_FLOW_ID = '00277ccf1511459c95001240cfd80f09';
